export const tableContainer = {
  marginBottom: 4,
  overflowX: 'auto',
  width: '100%',
};

export const tableCellBorderRight = { borderRight: '1px solid' };

export const tableRowCellBorderRight = {
  borderRight: '1px solid',
  borderRightColor: 'grey.400',
};

export const invoiceTableHeader = {
  backgroundColor: 'aliceblue',
  verticalAlign: 'center',
  fontWeight: 'bold',
  fontSize: '1rem',
};

export const invoiceTable = {
  textAlign: 'left',
  borderBottom: '1px #dee2e6 solid',
  borderRight: '1px #dee2e6 solid',
  borderLeft: '1px #dee2e6 solid',
};

export const invoiceTableCell = {
  border: '1px solid #dee2e6',
  textAlign: 'center',
};
